import type { UserBalanceWithFundSource } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import type { WalletClient } from "./client";
import {
  type FundSourceFiltersById,
  attachFundSourceFilterCounts,
  normalizeFundSourceFilterMap,
} from "./fund-source-filters";
import { sortBalanceWithFundSources } from "./sort-balance-with-fund-sources";

/**
 * balanceWithFundSourcesに対応する店舗・地域の利用制限を別RPCで取得し、
 * それを反映した優先度でソートする。
 *
 * getMyBalances自体はこの関数では呼ばない。呼び出し元がgetStoreなど他の
 * リクエストとPromise.allで並列化できるようにするため。
 */
export async function getSortedBalancesWithFundSources(
  client: WalletClient,
  balanceWithFundSources: UserBalanceWithFundSource[],
): Promise<{
  sortedBalances: ReturnType<typeof sortBalanceWithFundSources>;
  filtersByFundSourceId: FundSourceFiltersById;
}> {
  const fundSourceIds = [
    ...new Set(
      balanceWithFundSources
        .map((balance) => balance.fundSource?.id)
        .filter((fundSourceId): fundSourceId is string =>
          Boolean(fundSourceId),
        ),
    ),
  ];

  const fundSourceFilterMapResponse =
    fundSourceIds.length > 0
      ? await client.getFundSourceFilterMap({ query: { fundSourceIds } })
      : undefined;

  const filtersByFundSourceId = normalizeFundSourceFilterMap(
    fundSourceFilterMapResponse?.filterMap,
  );

  const sortedBalances = sortBalanceWithFundSources(
    attachFundSourceFilterCounts(balanceWithFundSources, filtersByFundSourceId),
  );

  return { sortedBalances, filtersByFundSourceId };
}
